var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "promotion-table-pane" },
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "200px" },
            attrs: { placeholder: "请输入活动名称", clearable: "" },
            model: {
              value: _vm.listQuery.keywords,
              callback: function ($$v) {
                _vm.$set(_vm.listQuery, "keywords", $$v)
              },
              expression: "listQuery.keywords",
            },
          }),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.search },
            },
            [_vm._v("\n      搜索\n    ")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-plus" },
              on: { click: _vm.handleBatch },
            },
            [_vm._v("\n      批量设置\n    ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          key: _vm.tableKey,
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            multiple: "",
            stripe: "",
            border: "",
            fit: "",
            "highlight-current-row": "",
            size: "mini",
          },
          on: { "selection-change": _vm.handleSelectionChange },
        },
        [
          _c("el-table-column", {
            attrs: { type: "selection", width: "50", align: "center" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "门店ID",
              prop: "storeId",
              align: "center",
              width: "180",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "门店名称",
              prop: "storeName",
              align: "left",
              width: "300",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [_vm._v(_vm._s(scope.row.storeName))]),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(scope.row.storeAddress))]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "预定/就餐日期",
              prop: "orderScene",
              align: "center",
              width: "280",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.bookingStartDateFormatter &&
                    scope.row.bookingEndDateFormatter
                      ? _c("div", [
                          _c("div", [
                            _vm._v(
                              "预定日期：[" +
                                _vm._s(scope.row.bookingStartDateFormatter) +
                                "] ~ [" +
                                _vm._s(scope.row.bookingEndDateFormatter) +
                                "]"
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              "就餐日期：[" +
                                _vm._s(scope.row.diningStartDateFormatter) +
                                "] ~ [" +
                                _vm._s(scope.row.diningEndDateFormatter) +
                                "]"
                            ),
                          ]),
                        ])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "预定分数", align: "left", width: "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.lunchQty
                      ? _c("div", [
                          _vm._v(
                            "\n          午餐：[" +
                              _vm._s(scope.row.lunchQty) +
                              "]\n        "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.dinnerQty
                      ? _c("div", [
                          _vm._v(
                            "\n          晚餐：[" +
                              _vm._s(scope.row.dinnerQty) +
                              "]\n        "
                          ),
                        ])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "预定内容", prop: "tiersRuleList", align: "left" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return _vm._l(scope.row.goodsList, function (item, idx) {
                    return _c("div", { key: "booking_goods_" + idx }, [
                      _vm._v("\n          " + _vm._s(item) + "\n        "),
                    ])
                  })
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "有效", width: "80", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-switch", {
                      on: {
                        change: function ($event) {
                          return _vm.handleToggleEnable(scope.row)
                        },
                      },
                      model: {
                        value: scope.row.markForEnable,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "markForEnable", $$v)
                        },
                        expression: "scope.row.markForEnable",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "操作", width: "100", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini" },
                        on: {
                          click: function ($event) {
                            return _vm.handleEdit(scope.row)
                          },
                        },
                      },
                      [_vm._v("\n          编辑\n        ")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination-container" },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.listQuery.page,
              "page-sizes": [10, 20, 50, 100],
              "page-size": _vm.listQuery.limit,
              total: _vm.total,
              layout: "total, sizes, prev, pager, next, jumper",
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }